window.app = window.app || {};

window.app.features = {
  el: {
    features: document.querySelectorAll(".mt-feature"),
    images: document.querySelectorAll(".mt-features__img"),
  },
  activeFeature: null,

  init: function () {
    this.activeFeature = this.el.features[0];
    this.activeImg = this.el.images[0];
    this.el.features.forEach((feature) => {
      feature.addEventListener("click", () => {
        const { index } = feature.dataset;
        this.activeFeature.classList.remove("active");
        this.activeFeature = feature;
        this.activeFeature.classList.add("active");

        this.activeImg.classList.remove("active");
        this.activeImg = this.el.images[index - 1];
        this.activeImg.classList.add("active");
      });
    });
  },
};

window.addEventListener("DOMContentLoaded", () => {
  window.app.features.init();
});
